module.exports = __webpack_public_path__ + "img/face-smirking.e78d4d11.svg";